// extracted by css-extract-rspack-plugin
export default {"content":"content-ck8n4r","documents":"documents-vJVvlI","title":"title-yLSbF0 text-headline-md","chips":"chips-R6IlSf"};